<template lang="pug">
.d-flex
  .flex-grow-1
    filter-inventory-category.mr-2(ref="category" :filter.sync="typeFilter" check-initial-value)
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-drug-group.mr-2(ref="group" :filter.sync="groupFilter" check-initial-value)
    filter-cost.mr-2(ref="cost" :filter.sync="costFilter" check-initial-value)
    filter-price.mr-2(ref="price" :filter.sync="priceFilter" check-initial-value)
    filter-stock(ref="balance" :filter.sync="stockFilter" check-initial-value)
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterInventoryCategory from '@/components/module/filter/FilterInventoryCategory.vue'
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterDrugGroup from '@/components/module/filter/FilterDrugGroup.vue'
import FilterCost from '@/components/module/filter/FilterCost.vue'
import FilterPrice from '@/components/module/filter/FilterPrice.vue'
import FilterStock from '@/components/module/filter/FilterStock.vue'

export default {
  name: 'FilterRow',
  components: { FilterInventoryCategory, FilterName, FilterDrugGroup, FilterCost, FilterPrice, FilterStock },
  props: ['filters', 'propFilters'],
  data: () => ({
    nameFilter: {},
    typeFilter: {},
    groupFilter: {},
    costFilter: {},
    priceFilter: {},
    stockFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.typeFilter.key) {
        filters.push(this.typeFilter)
      }
      if (this.costFilter.key) {
        if (this.costFilter.key === 'between') {
          const values = this.costFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.costFilter)
        }
      }
      if (this.priceFilter.key) {
        if (this.priceFilter.key === 'between') {
          const values = this.priceFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.priceFilter)
        }
      }
      if (this.groupFilter.key) {
        filters.push(this.groupFilter)
      }
      if (this.stockFilter.key) {
        if (this.stockFilter.key === 'between') {
          const values = this.stockFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.stockFilter)
        }
      }
      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        typeFilter: this.typeFilter,
        groupFilter: this.groupFilter,
        costFilter: this.costFilter,
        priceFilter: this.priceFilter,
        stockFilter: this.stockFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.typeFilter = this.propFilters?.typeFilter || {}
      this.groupFilter = this.propFilters?.groupFilter || {}
      this.costFilter = this.propFilters?.costFilter || {}
      this.priceFilter = this.propFilters?.priceFilter || {}
      this.stockFilter = this.propFilters?.stockFilter || {}
      this.$nextTick(() => {
        this.$refs.category.setData()
        this.$refs.name.setData()
        this.$refs.group.setData()
        this.$refs.cost.setData()
        this.$refs.price.setData()
        this.$refs.balance.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.typeFilter = {}
      this.groupFilter = {}
      this.costFilter = {}
      this.priceFilter = {}
      this.stockFilter = {}
    }
  }
}
</script>